// Exports a constant string (BookTitleMatch) which is a
// case-sensitive pre-compiled regular expression that will match any
// of the book titles listed below, making it a kind of "data detector".

export const BookTitleMatch = (function() {
  // The Christian Harmony
  // Christian Harmony
  // Christian Harmony, Carolina Edition

  var ch = '(The )?(Ingalls )?Christian Harmony(, Carolina Edition)?';

  // The B.F. White Sacred Harp
  // The B.F. White Sacred Harp, 1992 Edition
  // The B.F. White Sacred Harp, Revised Cooper Edition
  //     B.F. White Sacred Harp, Revised Cooper Edition
  //     B.F. White Sacred Harp, Cooper Edition

  var bf =
    '(The )?B.F. White Sacred Harp((, d{4} Edition)|(, (Revised )?Cooper Edition))'; // eslint-disable-line no-useless-escape

  // Cooper Book
  // Cooper Edition

  var cb = 'Cooper Book|Cooper Edition';

  // Missouri Harmony
  // Missouri Harmony, 2005 Revision
  // 1996 Songs from The Missouri Harmony

  var mh = '(1996 Songs from )?Missouri Harmony(, 2005 Revision)?';

  //      Kentucky Harmonist
  // 1820 Kentucky Harmonist
  // 1820 Kentucky Harmony

  var kh = '(The )?(1820 )?Kentucky (Harmonist|Harmony)';

  //      Colored Sacred Harp
  //          The Sacred Harp
  //          The Sacred Harp, 1991 Edition

  // BUT NOT: The Sacred Harp Publishing Company
  // BUT NOT: The Sacred Harp Musical Heritage Association

  var sh =
    '((The|((The )?Colored)) )Sacred Harp(?!( Publishing Company)|( Musical Heritage Association))(, 1991 Edition)?';

  // The Social Harp
  // Denson Revision
  // White Book
  // The Good Old Songs
  // New Harp of Columbia
  // Southern Harmony
  // Oberlin Harmony

  var misc =
    '((The )?Social Harp)|((The )?Denson Revision)|((The )?(J. *L. )?White Book)|((The )?Good Old Songs)|((The )?New Harp of Columbia)|((The )?Southern Harmony)|((The )?Oberlin Harmony)';

  // Lloyd Hymnal
  // Lloyd’s Hymnal

  var lh = 'Lloyd(’s)? Hymnal';

  // Awake, My Soul (DVD), plus some

  var aw =
    '(Awake,? My Soul)|((The )?American Vocalist)|((The )?Shenandoah Harmony)';

  // Directory and Minutes of Sacred Harp Singings

  var min = 'Directory and Minutes of Sacred Harp Singings';

  // Some more books identified in the abbreviations table

  var xh = '((The )?(Keystone|Northern|Georgian|Norumbega|American) Harmony)';

  var ms =
    '(The )?((American Christmas Harp)|(Eclectic Harmony( II)?)|(Harmonia Sacra)|(James Book)|(Old School Hymnal))';

  var all =
    '((' +
    ch +
    ')|(' +
    bf +
    ')|(' +
    cb +
    ')|(' +
    mh +
    ')|(' +
    kh +
    ')|(' +
    sh +
    ')|(' +
    misc +
    ')|(' +
    lh +
    ')|(' +
    aw +
    ')|(' +
    min +
    ')|(' +
    xh +
    ')|(' +
    ms +
    '))';

  return all;
})();



// WEBPACK FOOTER //
// ./src/book_title_match.js